import { Button } from '@mui/material';
import CusDataGrid from 'components/CusDataGrid';
import MainCard from 'components/MainCard';
import useMain from 'hooks/useMain';
import React, { useState } from 'react';
import { DropzoneArea } from 'react-mui-dropzone';
import { settingColumns } from './column';
import { useSetting } from './useSetting';
import { utils, read, write, writeFileXLSX } from 'xlsx';
import { SETTING_TYPE } from 'pages/module/constant';
import { settingFields } from './field';
import * as FileSaver from 'file-saver';
import { isNumber } from 'lodash';
import { downloadExcel, handleAlertMessage, handleAsyncCall } from 'utils/common';
import { micService } from 'services/mic';
import moment from 'moment';
import { Button1 } from 'components/Button';

export const exportCSV = (csvData, fileName) => {
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  const ws = utils.json_to_sheet(csvData);
  const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
  const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};

const SettingImport = () => {
  const { t, project } = useMain();
  const [importData, setImportData] = useState([]);
  const { currentSettingType, rows, rowKey, companyTypeOptions, isLoading, setLoading } = useSetting({ importData });

  const handleValidateUpload = (result) => {
    if (!_.isEmpty(result)) {
      handleAsyncCall({
        t,
        service: micService.validateSettingExcel,
        params: {
          projid: project?.ProjId,
          masterType: currentSettingType,
          file: result[0]
        },
        successCb: (res) => {
          const mappedUploadedData = res.data.map(({ data, status, message }, i) => ({
            Id: `setting-${currentSettingType}-data-${i}`,
            ...data,
            RowStatus: status,
            message
          }));
          setImportData(mappedUploadedData);
        }
      });
      return;
    }
  };

  const handleConfirmUpload = () => {
    const mappedImportedData = importData.map(({ RowStatus, message, ...rest }) => ({
      data: rest,
      status: RowStatus,
      message
    }));
    handleAsyncCall({
      service: micService.confirmUploadSettingExcel,
      params: {
        masterType: currentSettingType,
        projid: project?.ProjId,
        data: mappedImportedData
      },
      successCb: (res) => {
        handleAlertMessage({
          icon: 'success',
          showCancelButton: false,
          text: t(res?.data)
        });
      }
    });
  };

  const handleDownload = () => {
    handleAsyncCall({
      service: micService.getSettingExcel,
      params: {
        projid: project?.ProjId,
        masterType: currentSettingType
      },
      successCb: (res) => {
        downloadExcel(res.data, `${currentSettingType} Setting ${moment(new Date()).format('DD/MM/YYYY')}`);
      }
    });
  };

  return (
    <>
      <MainCard
        sx={{
          '.MuiDropzoneArea-root': {
            minHeight: 0
          }
        }}
      >
        <DropzoneArea
          acceptedFiles={['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']}
          useChipsForPreview={false}
          showPreviewsInDropzone={false}
          onChange={handleValidateUpload}
        />
      </MainCard>
      <MainCard>
        <CusDataGrid
          showExport={false}
          cusToolbarComponents={() => (
            <>
              <Button1
                text={t('DOWNLOAD')}
                sx={{ ml: [0, 2], mt: [2, 'auto'] }}
                onClick={() => {
                  handleDownload();
                }}
              />
              <Button1
                text={t('UPDATE')}
                sx={{ ml: [0, 2], mt: [2, 'auto'] }}
                disabled={_.isEmpty(importData)}
                onClick={() => {
                  handleConfirmUpload();
                }}
              />
            </>
          )}
          loading={isLoading}
          disableSelectionOnClick
          getRowId={(row) => row[rowKey]}
          rows={_.isEmpty(importData) ? rows : importData}
          columns={settingColumns({ currentSettingType, t, forImport: true })}
        />
      </MainCard>
    </>
  );
};

export default SettingImport;
